var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "embed-player" }, [
    _c(
      "div",
      { staticClass: "embed-player__emotions" },
      [_c("EmotionPanel")],
      1
    ),
    _c("iframe", {
      ref: "iframe",
      attrs: { id: _vm.playerId, allow: "fullscreen", allowfullscreen: "" },
      on: { load: _vm.onLoad }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }